import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {index > 0 ? <i className="ri-arrow-right-s-line text-foreground-400" /> : null}
            {item.to && !isLast ? (
              <Link to={item.to} className="transition-colors hover:text-foreground-900">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-foreground-800' : ''} aria-current={isLast ? 'page' : undefined}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}